import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.WorkflowSettingsPopupContent.SectionUrlOverriding', {
    title: 'Overwrite the “go to“ button in Xero',
    subtitle:
        "ApprovalMax can add a “Go to ApprovalMax“ button to each Xero document when it's pulled for approval. Do you want us to rewrite this button if it's used by another app?",
    optionYes: 'Yes, rewrite the button',
    optionNo: 'No, do not rewrite the button',
});
